module.exports = __webpack_public_path__ + "static/media/fcdc999d-a069-4faf-b0cf-f29a78e38ad3.3d169204.jpg";